import { call, put } from 'redux-saga/effects';

import { addParticipants } from '@api/messages';
import {
  messagesAddParticipantsSuccessAction,
  messagesAddParticipantsFailureAction,
} from '@store/messages/messagesDetail/messagesDetail.actions';
import { toastError } from '@store/notifications';

export const handleAddParticipants = function* ({ payload = {} }) {
  try {
    const response = yield call(addParticipants, payload);

    yield put(messagesAddParticipantsSuccessAction(response));

    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const message = error.data?.nonFieldErrors ||
      error.data?.fieldErrors?.participants || {
        defaultMessage: 'An unexpected error occurred, please try again.',
        id: 'global.notification.api-error-default',
      };

    yield put([toastError({ message }), messagesAddParticipantsFailureAction()]);
  }
};
